import { render, staticRenderFns } from "./VoiceRoomHeader.vue?vue&type=template&id=8e918056&scoped=true"
import script from "./VoiceRoomHeader.vue?vue&type=script&lang=js"
export * from "./VoiceRoomHeader.vue?vue&type=script&lang=js"
import style0 from "./VoiceRoomHeader.vue?vue&type=style&index=0&id=8e918056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e918056",
  null
  
)

export default component.exports